import { render, staticRenderFns } from "./SideNavItems.vue?vue&type=template&id=d666b542&scoped=true"
import script from "./SideNavItems.vue?vue&type=script&lang=js"
export * from "./SideNavItems.vue?vue&type=script&lang=js"
import style0 from "./SideNavItems.vue?vue&type=style&index=0&id=d666b542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d666b542",
  null
  
)

export default component.exports